export default __webpack_public_path__ + "static/media/benefit_18@2x.006b5917.png";